import { Layout, Grid } from "antd";
import React from "react";
import { MAINBAR_WIDTH } from "../constants";
import Logo from "./Logo";

const { useBreakpoint } = Grid;

const NavHeader = ({ children, theme = "light" }) => {
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    return (
        <div
            style={{
                position: "fixed",
                left: isMobile ? 0 : MAINBAR_WIDTH,
                backgroundColor: theme === "light" ? "white" : "black",
                zIndex: 5,
                width: "100%",
                // height: "30px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                boxShadow: "0px 2px 9px -4px rgba(107,107,107,1)",
            }}
        >
            <div
                style={{
                    margin: "auto 16px",
                    marginLeft: "20px",
                }}
            >
                <Logo theme={theme} />
            </div>
            <div
                style={{
                    flex: 1,
                    height: "100%",
                    // backgroundColor: "yellow",
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default NavHeader;
